import { useQuery } from '@apollo/client';
import query from '../../queries/vehicleModels';

export default function useVehicleModels() {
  const { data, ...rest } = useQuery(query);

  const vehicleModels = data?.vehicleModels;

  return {
    vehicleModels,
    ...rest
  };
}
